import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ShowFileDialog } from '../dialogs-show-file/show-file-dialog.component';

@Component({
    selector: 'instruction-dialog',
    templateUrl: 'instruction-dialog.component.html',
    styleUrls: ['instruction-dialog.component.scss']
})
export class InstructionDialog implements OnInit {
    
    numInstruction:number;
    datecreation: any;
    datesortie: any;
    datedebperiode: any;

    constructor(
        public dialogRef: MatDialogRef<InstructionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.numInstruction = this.data.numInstruction
        this.datecreation = this.data.datecreation
        this.datesortie = this.data.datesortie
        this.datedebperiode = this.data.datedebperiode
    }
    dismissDialog(){
        this.dialogRef.close();
    }
}